<template>
  <div class="container_OfertarForm">
    <ValidationObserver ref="formOfertar">
      <b-form v-on:submit.prevent>
        <div v-if="!phase5" class="form_OfertarForm">
          <b-row>
            <b-col
              md="7"
              lg="7"
              class="separator"
              :class="phase1 || phase2 || phase3 || phase4 ? '' : 'invisible'"
            >
              <div class="pl-2 pr-2">
                <b-card-title v-if="isEditar">
                  {{ $t("label.edicion.oferta") }}
                </b-card-title>
                <b-card-title v-else>{{ $t("label.creacion.oferta") }}</b-card-title>

                <!-- Phase 1 -->
                <b-row class="mt-5" v-if="phase1">
                  <b-col cols="1">
                    <b-button disabled pill variant="primary" class="btn-number font-weight-bold"
                      >1</b-button
                    >
                  </b-col>
                  <b-col lg="5" md="5">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="'required'"
                      name="select-client"
                    >
                      <b-form-group>
                        <multiselect
                          id="select-client"
                          name="select-client"
                          aria-describedby="select-client-feedback"
                          :state="errors[0] ? false : null"
                          :class="errors[0] ? 'is-invalid' : ''"
                          :options="getClientesAll"
                          v-model="clienteSelected"
                          label="desCliente"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :multiple="false"
                          :preserve-search="false"
                          select-label=""
                          deselect-label=""
                          selected-label=""
                          :placeholder="$t('label.cliente')"
                          track-by="id"
                          @input="clienteSelectedInput"
                          :disabled="isEditar"
                        >
                          <span slot="noOptions">{{ $t("text.no.options") }}</span>
                          <span slot="noResult">{{ $t("text.no.results") }}</span>
                        </multiselect>
                        <b-form-invalid-feedback id="select-client-feedback">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <b-col lg="5" md="5">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="{ required: clienteSelected !== null && delegationSelected === null }"
                      name="select-delegation"
                    >
                      <b-form-group>
                        <multiselect
                          id="select-delegation"
                          name="select-delegation"
                          aria-describedby="select-delegation-feedback"
                          :state="errors[0] ? false : null"
                          :class="errors[0] ? 'is-invalid' : ''"
                          :options="delegations"
                          v-model="delegationSelected"
                          label="desDelegacion"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :multiple="false"
                          :preserve-search="false"
                          select-label=""
                          deselect-label=""
                          selected-label=""
                          :placeholder="$t('label.delegacion')"
                          track-by="id"
                        >
                          <span slot="noOptions">{{ $t("text.no.options") }}</span>
                          <span slot="noResult">{{ $t("text.no.results") }}</span>
                        </multiselect>
                        <b-form-invalid-feedback id="select-delegation-feedback">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="phase1 && clienteSelected?.pais.hasTransportadora">
                  <b-col cols="1"> </b-col>
                  <b-col lg="5" md="5">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="'required'"
                      name="select-transportadora"
                    >
                      <b-form-group>
                        <multiselect
                          id="select-transportadora"
                          name="select-transportadora"
                          aria-describedby="select-transportadora-feedback"
                          :state="errors[0] ? false : null"
                          :class="errors[0] ? 'is-invalid' : ''"
                          :options="transportadorasOptions"
                          v-model="transportadoraSelected"
                          label="descripcion"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :multiple="false"
                          :preserve-search="false"
                          select-label=""
                          deselect-label=""
                          selected-label=""
                          :placeholder="$t('label.transportadora')"
                          track-by="id"
                        >
                          <span slot="noOptions">{{ $t("text.no.options") }}</span>
                          <span slot="noResult">{{ $t("text.no.results") }}</span>
                        </multiselect>
                        <b-form-invalid-feedback id="select-transportadora-feedback">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="
                    phase1 && delegationSelected && clienteSelected?.pais.intercambioDelegaciones
                  "
                >
                  <b-col cols="1"></b-col>
                  <b-col lg="10" md="10">
                    <div class="label_TitleLeftToDelegacionesOpcionales">
                      {{ titleLeftToDelegacionesOpcionales }}
                    </div>
                    <PFormSelectTranslateItems
                      v-model="delegationsOptional"
                      :options="delegationsOptionalFiltered"
                      optionValue="id"
                      optionText="desDelegacion"
                      :titleRight="$t('label.seleccionados')"
                      :titleLeft="$t('label.delegacion')"
                    ></PFormSelectTranslateItems>
                  </b-col>
                </b-row>
                <b-row class="mb-5" v-if="phase1">
                  <b-col cols="1"> </b-col>
                  <b-col lg="11" md="11" v-if="clienteSelected">
                    <span class="recent-label">{{ $t("label.divisa") }}</span>
                    <b-row>
                      <b-col>
                        <b-form-group v-if="clienteSelected">
                          <b-form-radio-group
                            v-model="divisaSelected"
                            buttons
                            button-variant="outline-primary"
                            class="mx-n1 radio-form-group"
                          >
                            <template v-for="divisa in divisas">
                              <b-form-radio
                                :value="divisa"
                                :key="divisa.id"
                                class="mx-1 form-radio"
                              >
                                {{ divisa.simbolo }} {{ divisa.codDivisa }}
                              </b-form-radio>
                            </template>
                          </b-form-radio-group>
                          <br />
                          <span
                            class="error-divisa"
                            v-if="clienteSelected && delegationSelected && !divisaSelected"
                            >{{ $t("validation.messages.required") }}</span
                          >
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- Phase 2 -->
                <b-row class="mt-5" v-if="phase2">
                  <b-col cols="1">
                    <b-button disabled pill variant="primary" class="btn-number font-weight-bold"
                      >2</b-button
                    >
                  </b-col>
                  <b-col lg="3" md="3" class="separator" v-if="!clienteSelected?.fakeCerts">
                    <span class="recent-label">{{ $t("label.saldo.restante") }}</span>
                    <br />
                    <span class="recent-label font-weight-bold" v-if="divisaSelected"
                      >{{ divisaSelected.simbolo }} {{ filterNumber(saldoRestante, 2) }}</span
                    >
                  </b-col>
                  <b-col lg="3" md="3" class="offset-md-1 offset-lg-1">
                    <span class="recent-label">{{ $t("label.total.ofertar") }}</span>
                    <br />
                    <span class="recent-label font-weight-bold" v-if="divisaSelected"
                      >{{ divisaSelected.simbolo }} {{ filterNumber(saldoOfertar, 2) }}</span
                    >
                  </b-col>
                </b-row>

                <b-row class="mt-5 mb-5" v-if="phase2">
                  <b-col cols="1"></b-col>
                  <b-col lg="11" md="11" class="panel-denominaciones mb-5">
                    <b-row class="ma-1 mr-5">
                      <b-col lg="3" md="3">
                        <b-card-title class="align-center">{{
                          $t("label.denominacion")
                        }}</b-card-title>
                      </b-col>
                      <b-col lg="3" md="3">
                        <b-card-title v-if="!clienteSelected?.fakeCerts">{{
                          $t("label.disponible")
                        }}</b-card-title>
                      </b-col>
                      <b-col lg="3" md="3" class="label-ofertado">
                        <b-card-title class="float-right">{{ $t("label.ofertado") }}</b-card-title>
                      </b-col>
                      <b-col lg="3" md="3" class="label-ofertado">
                        <b-card-title class="float-right">{{ $t("label.cantidad") }}</b-card-title>
                      </b-col>
                    </b-row>
                    <!-- Itera sobre los detalles de saldo -->
                    <template v-for="(detalleSaldo, index) in detallesSaldo">
                      <div
                        v-if="detalleSaldo.saldoActual !== 0"
                        :key="detalleSaldo.id"
                        class="mr-5"
                      >
                        <hr />
                        <b-row>
                          <b-col>
                            <span>
                              {{ detalleSaldo.calidadDenominacion.denominacion.codDenominacion }}
                              {{ detalleSaldo.calidadDenominacion.desCalidad }}
                            </span>
                          </b-col>
                          <b-col>
                            <span v-if="!clienteSelected?.fakeCerts">
                              {{ filterNumber(detalleSaldo.saldoActual, 2) }}
                            </span>
                          </b-col>
                          <b-col mr="3">
                            <div>
                              <span
                                v-if="divisaSelected && detalleSaldo.calidadDenominacion"
                                class="denominacion-importe float-right"
                                v-b-toggle="
                                  `calidadDenominacion-${detalleSaldo.calidadDenominacion.id.toString()}`
                                "
                                @click="
                                  (detalleSaldo.calidadDenominacion.importeSelected = true),
                                    (detalleSaldo.calidadDenominacion.cantidadSelected = false)
                                "
                                >{{ divisaSelected.simbolo }}
                                {{
                                  filterNumber(detalleSaldo.calidadDenominacion.importe, 2)
                                }}</span
                              >
                            </div>
                          </b-col>
                          <b-col mr="3">
                            <div>
                              <span
                                v-if="divisaSelected && detalleSaldo.calidadDenominacion"
                                class="denominacion-importe float-right"
                                v-b-toggle="
                                  `cantidad-${detalleSaldo.calidadDenominacion.id.toString()}`
                                "
                                @click="
                                  (detalleSaldo.calidadDenominacion.importeSelected = false),
                                    (detalleSaldo.calidadDenominacion.cantidadSelected = true)
                                "
                              >
                                {{ detalleSaldo.calidadDenominacion.cantidad }}
                              </span>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row
                          v-if="
                            detalleSaldo.calidadDenominacion &&
                            detalleSaldo.calidadDenominacion.denominacion
                          "
                        >
                          <b-col>
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="`min_value:0|valid-denomination:${
                                detalleSaldo.calidadDenominacion.denominacion.numValue
                              }
                              ${
                                !clienteSelected?.fakeCerts
                                  ? '|max_value:' + detalleSaldo.saldoActual
                                  : ''
                              }`"
                              :name="`cantidad-denominacion-importe_${index}`"
                            >
                              <b-collapse
                                :id="`calidadDenominacion-${detalleSaldo.calidadDenominacion.id.toString()}`"
                                v-if="
                                  detalleSaldo.calidadDenominacion?.importeSelected &&
                                  !detalleSaldo.calidadDenominacion.cantidadSelected
                                "
                              >
                                <b-card class="input-card">
                                  <b-card-body>
                                    <b-row>
                                      <b-col offset-lg="3" offset-md="3" lg="6" md="6">
                                        <b-form-group>
                                          <b-form-input
                                            type="number"
                                            min="0"
                                            :max="detalleSaldo.saldoActual"
                                            @blur="
                                              verifyImporteToZeroInDetalleSaldoById(detalleSaldo.id)
                                            "
                                            :step="
                                              detalleSaldo.calidadDenominacion.denominacion.numValue
                                            "
                                            v-model="detalleSaldo.calidadDenominacion.importe"
                                            :name="`cantidad-denominacion-importe_${index}`"
                                            :id="`cantidad-denominacion-importe_${index}`"
                                            :state="errors[0] ? false : null"
                                            :aria-describedby="`cantidad-denominacion-feedback_${index}`"
                                            @change="
                                              calculaCantidad(detalleSaldo.calidadDenominacion)
                                            "
                                          ></b-form-input>
                                        </b-form-group>
                                      </b-col>
                                    </b-row>
                                    <b-input
                                      type="range"
                                      min="0"
                                      :max="detalleSaldo.saldoActual"
                                      :step="detalleSaldo.calidadDenominacion.denominacion.numValue"
                                      v-model="detalleSaldo.calidadDenominacion.importe"
                                      class="mt-1"
                                    ></b-input>
                                  </b-card-body>
                                </b-card>
                              </b-collapse>
                              <b-form-invalid-feedback
                                :id="`cantidad-denominacion-feedback_${index}`"
                                class="d-block"
                              >
                                {{ errors[0] }}
                              </b-form-invalid-feedback>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="`min_value:0|integer${
                                !clienteSelected?.fakeCerts
                                  ? '|max_value:' + detalleSaldo.cantidad
                                  : ''
                              }`"
                              :name="`cantidad_${index}`"
                            >
                              <b-collapse
                                :id="`cantidad-${detalleSaldo.calidadDenominacion.id.toString()}`"
                                v-if="
                                  !detalleSaldo.calidadDenominacion.importeSelected &&
                                  detalleSaldo.calidadDenominacion.cantidadSelected
                                "
                              >
                                <b-card class="input-card">
                                  <b-card-body>
                                    <b-row>
                                      <b-col offset-lg="3" offset-md="3" lg="6" md="6">
                                        <b-form-group>
                                          <b-input
                                            type="number"
                                            min="0"
                                            :max="
                                              detalleSaldo.saldoActual /
                                              detalleSaldo.calidadDenominacion.denominacion.numValue
                                            "
                                            :step="1"
                                            v-model="detalleSaldo.calidadDenominacion.cantidad"
                                            :name="`cantidad_${index}`"
                                            :id="`cantidad_${index}`"
                                            :state="errors[0] ? false : null"
                                            :aria-describedby="`cantidad-feedback_${index}`"
                                            @change="
                                              calculaImporte(detalleSaldo.calidadDenominacion)
                                            "
                                          ></b-input>
                                        </b-form-group>
                                      </b-col>
                                    </b-row>
                                    <b-input
                                      type="range"
                                      min="0"
                                      :max="
                                        detalleSaldo.saldoActual /
                                        detalleSaldo.calidadDenominacion.denominacion.numValue
                                      "
                                      :step="1"
                                      v-model="detalleSaldo.calidadDenominacion.cantidad"
                                      class="mt-1"
                                      @change="calculaImporte(detalleSaldo.calidadDenominacion)"
                                    ></b-input>
                                  </b-card-body>
                                </b-card>
                              </b-collapse>
                              <b-form-invalid-feedback
                                :id="`cantidad-feedback_${index}`"
                                class="d-block"
                              >
                                {{ errors[0] }}
                              </b-form-invalid-feedback>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                      </div>
                    </template>
                    <!-- Itera sobre las calidades de denominación -->
                    <template v-for="(calidadDenominacion, index) in calidadesDenominacion">
                      <div :key="calidadDenominacion.id" class="mr-5">
                        <hr />
                        <b-row>
                          <b-col>
                            <span
                              >{{ calidadDenominacion.denominacion.codDenominacion }}
                              {{ calidadDenominacion.desCalidad }}</span
                            >
                          </b-col>
                          <b-col> </b-col>
                          <b-col mr="3">
                            <div>
                              <span
                                v-if="divisaSelected"
                                class="denominacion-importe float-right"
                                v-b-toggle="
                                  `calidadDenominacion-${calidadDenominacion.id.toString()}`
                                "
                                @click="
                                  (calidadDenominacion.importeSelected = true),
                                    (calidadDenominacion.cantidadSelected = false)
                                "
                                >{{ divisaSelected.simbolo }}
                                {{ filterNumber(calidadDenominacion.importe, 2) }}</span
                              >
                            </div>
                          </b-col>
                          <b-col mr="3">
                            <div>
                              <span
                                v-if="divisaSelected"
                                class="denominacion-importe float-right"
                                v-b-toggle="`cantidad-${calidadDenominacion.id.toString()}`"
                                @click="
                                  (calidadDenominacion.importeSelected = false),
                                    (calidadDenominacion.cantidadSelected = true)
                                "
                              >
                                {{ calidadDenominacion.cantidad }}</span
                              >
                            </div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="`min_value:0|valid-denomination:${calidadDenominacion.denominacion.numValue}`"
                              :name="`cantidad-denominacion_${index}`"
                            >
                              <b-collapse
                                :id="`calidadDenominacion-${calidadDenominacion.id.toString()}`"
                                v-if="
                                  calidadDenominacion.importeSelected &&
                                  !calidadDenominacion.cantidadSelected
                                "
                              >
                                <b-card class="input-card">
                                  <b-card-body>
                                    <b-row>
                                      <b-col offset-lg="3" offset-md="3" lg="6" md="6">
                                        <b-form-group>
                                          <b-input
                                            type="number"
                                            min="0"
                                            max="999999999"
                                            :step="calidadDenominacion.denominacion.numValue"
                                            v-model="calidadDenominacion.importe"
                                            :name="`cantidad-denominacion_${index}`"
                                            :id="`cantidad-denominacion_${index}`"
                                            :state="errors[0] ? false : null"
                                            :aria-describedby="`cantidad-denominacion-feedback_${index}`"
                                            @change="calculaCantidad(calidadDenominacion)"
                                          />
                                        </b-form-group>
                                      </b-col>
                                    </b-row>
                                    <b-input
                                      type="range"
                                      min="0"
                                      max="999999999"
                                      :step="calidadDenominacion.denominacion.numValue"
                                      v-model="calidadDenominacion.importe"
                                      class="mt-1"
                                      @change="calculaCantidad(calidadDenominacion)"
                                    ></b-input>
                                  </b-card-body>
                                </b-card>
                              </b-collapse>
                              <b-form-invalid-feedback
                                :id="`cantidad-denominacion-feedback_${index}`"
                                class="d-block"
                              >
                                {{ errors[0] }}
                              </b-form-invalid-feedback>
                            </ValidationProvider>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col>
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="`min_value:0|integer`"
                              :name="`cantidad_${index}`"
                            >
                              <b-collapse
                                :id="`cantidad-${calidadDenominacion.id.toString()}`"
                                v-if="
                                  !calidadDenominacion.importeSelected &&
                                  calidadDenominacion.cantidadSelected
                                "
                              >
                                <b-card class="input-card">
                                  <b-card-body>
                                    <b-row>
                                      <b-col offset-lg="3" offset-md="3" lg="6" md="6">
                                        <b-form-group>
                                          <b-input
                                            type="number"
                                            min="0"
                                            max="1666666"
                                            :step="1"
                                            v-model="calidadDenominacion.cantidad"
                                            :name="`cantidad_${index}`"
                                            :id="`cantidad_${index}`"
                                            :state="errors[0] ? false : null"
                                            :aria-describedby="`cantidad-feedback_${index}`"
                                            @change="calculaImporte(calidadDenominacion)"
                                          ></b-input>
                                        </b-form-group>
                                      </b-col>
                                    </b-row>
                                    <b-input
                                      type="range"
                                      min="0"
                                      max="1666666"
                                      :step="1"
                                      v-model="calidadDenominacion.cantidad"
                                      class="mt-1"
                                      @change="calculaImporte(calidadDenominacion)"
                                    ></b-input>
                                  </b-card-body>
                                </b-card>
                              </b-collapse>
                              <b-form-invalid-feedback
                                :id="`cantidad-feedback_${index}`"
                                class="d-block"
                              >
                                {{ errors[0] }}
                              </b-form-invalid-feedback>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                      </div>
                    </template>
                  </b-col>
                </b-row>

                <!-- Phase 3 -->
                <b-row class="mt-5" style="margin-bottom: 5rem" v-if="phase3">
                  <b-col>
                    <b-row>
                      <b-col cols="1">
                        <b-button
                          disabled
                          pill
                          variant="primary"
                          class="btn-number font-weight-bold"
                          >3</b-button
                        >
                      </b-col>
                      <b-col>
                        <b-row class="mb-4" v-if="!clienteSelected?.pais.hasTransportadora">
                          <b-col lg="5" md="5">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="'required'"
                              name="select-fecha-expiracion"
                            >
                              <b-form-group>
                                <label class="recent-label" for="select-fecha-expiracion">
                                  {{ $t("label.fecha.expiracion") }}
                                </label>
                                <b-form-datepicker
                                  id="select-fecha-expiracion"
                                  name="select-fecha-expiracion"
                                  v-model="fechaExpiracion"
                                  :state="errors[0] ? false : null"
                                  aria-describedby="fecha-expiracion-feedback"
                                  type="date"
                                  :min="
                                    new Date(
                                      new Date().getFullYear(),
                                      new Date().getMonth(),
                                      new Date().getDate()
                                    )
                                  "
                                  :date-format-options="{
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                  }"
                                />
                                <b-form-invalid-feedback id="fecha-expiracion-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                        <b-row class="mb-4" v-if="!clienteSelected?.pais.hasTransportadora">
                          <b-col lg="5" md="5">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="'required|date_future_oferta'"
                              name="select-hora-expiracion"
                            >
                              <b-form-group>
                                <label class="recent-label d-block" for="select-hora-expiracion">
                                  {{ $t("label.hora.expiracion") }}
                                </label>
                                <b-time
                                  id="select-hora-expiracion"
                                  name="select-hora-expiracion"
                                  v-model="horaExpiracion"
                                  :state="errors[0] ? false : null"
                                  aria-describedby="fecha-hora-feedback"
                                  :hide-header="true"
                                  :class="errors[0] ? 'is-invalid' : null"
                                />
                                <b-form-invalid-feedback id="fecha-hora-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <label class="recent-label" for="radio-coste">
                              {{ $t("label.coste") }}
                            </label>
                          </b-col>
                          <b-col v-if="clienteSelected?.pais.hasTasa">
                            <label class="recent-label" for="select-tasa">
                              {{ $t("label.tasa") }}
                            </label>
                          </b-col>
                        </b-row>
                        <b-row class="mb-4">
                          <b-col>
                            <b-form-group>
                              <b-form-radio-group
                                v-model="costeSelected"
                                buttons
                                button-variant="outline-primary"
                                class="mx-n1"
                                id="radio-coste"
                              >
                                <template v-for="coste in getCostes">
                                  <b-form-radio :value="coste" :key="coste.id" class="mx-1">
                                    {{ coste.codParametro }}
                                  </b-form-radio>
                                </template>
                              </b-form-radio-group>
                            </b-form-group>
                          </b-col>
                          <b-col
                            v-if="
                              clienteSelected?.pais.hasTasa && !clienteSelected?.pais.hasTasaEnteros
                            "
                          >
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="'between:0,100|required'"
                              name="select-tasa"
                            >
                              <b-form-group>
                                <b-input-group append="%" :class="errors[0] ? 'is-invalid' : null">
                                  <b-form-input
                                    id="select-tasa"
                                    type="number"
                                    append="%"
                                    min="0"
                                    max="100"
                                    step="0.00001"
                                    v-model="tasa"
                                    name="select-tasa"
                                    :state="errors[0] ? false : null"
                                    aria-describedby="tasa-feedback"
                                  ></b-form-input>
                                </b-input-group>
                                <b-form-invalid-feedback id="tasa-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                          <b-col
                            v-if="
                              clienteSelected?.pais.hasTasa && clienteSelected?.pais.hasTasaEnteros
                            "
                          >
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="'required|regex:^\\d+$|between:0,12'"
                              name="select-tasa"
                            >
                              <b-form-group>
                                <b-input-group
                                  append="x 10.000"
                                  :class="errors[0] ? 'is-invalid' : null"
                                >
                                  <b-form-input
                                    id="select-tasa"
                                    type="number"
                                    append="x 10.000"
                                    min="0"
                                    max="12"
                                    step="1"
                                    v-model="tasa"
                                    name="select-tasa"
                                    :state="errors[0] ? false : null"
                                    aria-describedby="tasa-feedback"
                                  ></b-form-input>
                                </b-input-group>
                                <b-form-invalid-feedback id="tasa-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                        <b-row v-if="clienteSelected?.pais.admiteAnonimo">
                          <b-col>
                            <b-form-group>
                              <div class="custom-control custom-switch">
                                <input
                                  type="checkbox"
                                  class="custom-control-input"
                                  id="inputAnonimo"
                                  v-model="anonimo"
                                />
                                <label class="custom-control-label" for="inputAnonimo">
                                  {{ $t("label.oferta.anonima") }}
                                </label>
                              </div>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- Phase 4 -->
                <b-row class="mt-4" style="margin-bottom: 5rem" v-if="phase4">
                  <b-col>
                    <div v-if="isShowBankField">
                      <b-row>
                        <b-col cols="1">
                          <b-button
                            disabled
                            pill
                            variant="primary"
                            class="btn-number font-weight-bold"
                            >4</b-button
                          ></b-col
                        >
                        <b-col lg="10" md="10" class="">
                          <ValidationProvider
                            v-slot="{ errors }"
                            rules="required|max:14|cuenta_corriente_pattern"
                            name="cuentaCorriente"
                          >
                            <b-form-group>
                              <span class="recent-label">{{ $t("label.cuentaCorriente") }}</span>
                              <b-row class="mt-10">
                                <b-input
                                  id="cuentaCorriente"
                                  name="cuentaCorriente"
                                  v-model="ofertaPaso4Params.cuentaCorriente"
                                  aria-describedby="cuenta_corriente-feedback"
                                  type="text"
                                  class="w-50"
                                  :hide-header="true"
                                  :class="errors[0] ? 'is-invalid' : ''"
                                  :state="errors[0] ? false : null"
                                />
                                <b-form-invalid-feedback id="cuenta_corriente-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-row>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="1"></b-col>
                        <b-col lg="10" md="10" class="">
                          <ValidationProvider
                            v-slot="{ errors }"
                            rules="required|max:11|ag_numero_sucursal_pattern"
                            name="agNumeroSucursal"
                          >
                            <b-form-group>
                              <span class="recent-label">{{ $t("label.agNumeroSucursal") }}</span>

                              <b-row class="mt-10">
                                <b-input
                                  id="agNumeroSucursal"
                                  name="agNumeroSucursal"
                                  v-model="ofertaPaso4Params.agNumeroSucursal"
                                  aria-describedby="ag_numero_sucursal-feedback"
                                  type="text"
                                  class="w-50"
                                  :class="errors[0] ? 'is-invalid' : ''"
                                  :state="errors[0] ? false : null"
                                />
                                <b-form-invalid-feedback id="ag_numero_sucursal-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-row>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="1"></b-col>
                        <b-col lg="10" md="10" class="">
                          <ValidationProvider
                            v-slot="{ errors }"
                            rules="required|length:11|numeric"
                            name="ispbBanco"
                          >
                            <b-form-group>
                              <span class="recent-label">{{ $t("label.ispbBanco") }}</span>
                              <b-row class="mt-10">
                                <b-input
                                  id="ispbBanco"
                                  name="ispbBanco"
                                  v-model="ofertaPaso4Params.ispbBanco"
                                  aria-describedby="ispb_banco-feedback"
                                  type="text"
                                  class="w-50"
                                  :class="errors[0] ? 'is-invalid' : ''"
                                  :state="errors[0] ? false : null"
                                />
                                <b-form-invalid-feedback id="ispb_banco-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-row>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="1"></b-col>
                        <b-col lg="10" md="10" class="">
                          <ValidationProvider
                            v-slot="{ errors }"
                            rules="required|max:18|cnpj_persona_pattern"
                            name="cnpjPersona"
                          >
                            <b-form-group>
                              <span class="recent-label">{{ $t("label.cnpjPersona") }}</span>
                              <b-row class="mt-10">
                                <b-input
                                  id="cnpjPersona"
                                  name="cnpjPersona"
                                  v-model="ofertaPaso4Params.cnpjPersona"
                                  aria-describedby="cnpj_persona-feedback"
                                  type="text"
                                  class="w-50"
                                  :class="errors[0] ? 'is-invalid' : ''"
                                  :state="errors[0] ? false : null"
                                />
                                <b-form-invalid-feedback id="cnpj_persona-feedback">
                                  {{ errors[0] }}
                                </b-form-invalid-feedback>
                              </b-row>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                    </div>
                    <b-row>
                      <b-col cols="1"> </b-col>
                      <b-col lg="10" md="10" class="">
                        <b-form-group>
                          <span class="recent-label">{{ $t("label.observaciones") }}</span>
                        </b-form-group>
                        <b-row class="mt-10">
                          <textarea
                            class="textarea"
                            id="observacionesOferta"
                            v-model="ofertaPaso4Params.observacionesOferta"
                            name="observacionesOferta"
                            type="text"
                          />
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- Phase 5 -->
                <b-row class="mt-5" v-if="phase5"> </b-row>

                <b-row v-if="!phase5" class="modal-transferencias-footer">
                  <b-col v-if="!phase1">
                    <b-button
                      pill
                      variant="outline-primary"
                      class="p-button-secondary"
                      @click="atras"
                    >
                      {{ $t("label.atras") }}
                    </b-button>
                  </b-col>
                  <b-col>
                    <b-button
                      pill
                      variant="primary"
                      class="p-button-primary"
                      :disabled="continuarCondition"
                      @click="continuar"
                    >
                      {{ $t("label.continuar") }}
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col md="5" lg="5">
              <div class="pl-2 pr-3">
                <resumen-oferta
                  :cliente="clienteSelected"
                  :delegacion="delegationSelected"
                  :transportadora="transportadoraSelected"
                  :divisa="divisaSelected"
                  :detalleSaldo="detallesSaldo"
                  :calidadesDenominacion="calidadesDenominacion"
                  :saldoRestante="saldoRestante"
                  :saldoOfertar="saldoOfertar"
                  :fechaExpiracion="fechaExpiracion"
                  :horaExpiracion="horaExpiracion"
                  :coste="costeSelected"
                  :anonimo="anonimo"
                  :tasa="tasa"
                  :ofertaPaso4Params="ofertaPaso4Params"
                  :isShowBankField="isShowBankField"
                  :final="phase5"
                ></resumen-oferta>
              </div>
            </b-col>
          </b-row>
        </div>

        <div v-if="phase5">
          <PConfirm :textButtonAccept="$t('label.ofertar')" @accept="ofertar" @cancel="cancelar">
            <template #title>
              {{ $t("label.ofertar.fondos") }}
              <span class="font-weight-bold"> {{ delegationSelected.desDelegacion }}</span>
              {{ $t("label.ofertar.fondos.descripcion") }}
            </template>
            <template #description>
              {{ ofertaDescription }}
            </template>
            <template #content>
              <b-card v-if="hasDetectedChanges" class="changes-content mb-4">
                <b-card-body class="alert m-3">
                  <h5 class="alert-heading">{{ $t("label.cambios.detectados") }}</h5>
                  <div v-html="changesHtmlContent" class="changes-list"></div>
                </b-card-body>
              </b-card>
              <b-card v-else-if="isEditar && !hasDetectedChanges" class="mb-4">
                <b-card-body class="alert m-3">
                  <h5 class="alert-heading">{{ $t("label.sin.cambios") }}</h5>
                  <p>{{ $t("label.no.cambios.detectados") }}</p>
                </b-card-body>
              </b-card>
              <PDataLine
                v-if="divisaSelected && !clienteSelected?.fakeCerts"
                :value="{
                  saldoRestante: divisaSelected.simbolo + ' ' + filterNumber(saldoRestante, 2),
                  saldoOfertar: divisaSelected.simbolo + ' ' + filterNumber(saldoOfertar, 2),
                }"
                :fields="{
                  saldoRestante: { title: $t('label.saldo.restante') },
                  saldoOfertar: { title: $t('label.total.ofertar') },
                }"
                :widthContent="true"
              />
              <PDataLine
                v-else-if="divisaSelected && clienteSelected?.fakeCerts"
                :value="{
                  saldoOfertar: divisaSelected.simbolo + ' ' + filterNumber(saldoOfertar, 2),
                }"
                :fields="{
                  saldoOfertar: { title: $t('label.total.ofertar') },
                }"
                :widthContent="true"
              />
            </template>
          </PConfirm>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import ResumenOferta from "./ResumenOferta.vue";
import {
  ActionOnOfertaDemanda,
  ICalidadDenominacion,
  ICliente,
  IDelegacion,
  IDenominacion,
  IDetallesSaldo,
  IDivisa,
  IOfertaDemanda,
  IParametro,
  ISaldo,
  ITransportadora,
} from "@/entities";
import Multiselect from "vue-multiselect";
import { Action, Getter } from "vuex-class";
import {
  IDetalleOfertaParams,
  IOfertaParams,
  IOfertaPaso4Params,
  ISaldoActualParams,
} from "@/services";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import AsyncComputed from "vue-async-computed-decorator";
import VueMethods from "@/vue-methods";
import { SweetAlertResult } from "sweetalert2";
import VueFilters from "@/vue-filters";
import * as mathjs from "mathjs";
import { PConfirm, PDataLine } from "@/components/look";

@Component({
  name: "ofertar-form",
  mixins: [VueMethods, VueFilters],
  components: {
    PConfirm,
    PDataLine,
    ResumenOferta,
    Multiselect,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class OfertarForm extends Vue {
  @Action("fetchSaldoActual") fetchSaldoActual!: (
    params?: ISaldoActualParams
  ) => Promise<ISaldo | undefined>;
  @Getter("getClienteSelected") getClienteSelected!: ICliente;
  @Getter("getClientesAll") getClientesAll!: ICliente[];
  @Getter("getCostes") getCostes!: IParametro[];
  @Prop({ required: false, default: "crear" }) actionSource!: string;
  @Prop({ required: false, default: null }) ofertaDemanda!: IOfertaDemanda;

  $refs!: {
    formOfertar: InstanceType<typeof ValidationObserver>;
  };

  phase1 = true;
  phase2 = false;
  phase3 = false;
  phase4 = false;
  phase5 = false;

  clienteSelected: ICliente | null = null;
  delegationSelected: IDelegacion | null = null;
  transportadoraSelected: ITransportadora | null = null;
  divisaSelected: IDivisa | null = null;

  saldoActual: ISaldo | null = null;
  detallesSaldo: IDetallesSaldo[] = [];
  saldoDisponible = 0;
  transportadorasOptions: ITransportadora[] | null = [];

  costeSelected: IParametro | null = null;
  fechaExpiracion: string | null = null;
  horaExpiracion: string | null = null;
  anonimo = false;
  tasa = 0;

  delegationsOptional: number[] = [];
  isShowBankField = false;
  ofertaParams: IOfertaParams | null = null;

  hasDetectedChanges = false;
  changesHtmlContent = "";

  ofertaPaso4Params: IOfertaPaso4Params = {
    relleno: false,
    cuentaCorriente: "",
    agNumeroSucursal: "",
    ispbBanco: "",
    cnpjPersona: "",
    observacionesOferta: "",
  };

  get delegationsOptionalFiltered(): IDelegacion[] {
    return this.delegations.filter((del) => del.id != this.delegationSelected?.id);
  }

  get delegationsOptionalSelected(): number[] {
    return this.delegationsOptional.filter((id) => id != this.delegationSelected?.id);
  }

  get divisas(): IDivisa[] {
    return this.clienteSelected?.divisas ?? [];
  }

  get calidadesDenominacion(): ICalidadDenominacion[] {
    const calidades: ICalidadDenominacion[] = [];
    if (this.clienteSelected?.fakeCerts) {
      const denominaciones = Object.assign([], this.divisaSelected?.denominaciones);
      denominaciones?.sort((a, b) => this.sortDescending(a, b, "numValue"));
      denominaciones?.forEach((denominacion: IDenominacion) => {
        denominacion.calidades?.forEach((calidad) => {
          if (calidad) {
            this.$set(calidad, "importe", 0);
            this.$set(calidad, "importeSelected", false);
            this.$set(calidad, "cantidad", 0);
            this.$set(calidad, "cantidadSelected", false);
            calidades.push(calidad);
          }
        });
      });
    }
    return calidades;
  }

  async mounted(): Promise<void> {
    this.validateFechaAndHoraExpriracion();
    if (this.ofertaDemanda && this.isEditar) {
      await this.setupEditarOferta();
    } else {
      this.clienteSelected = this.getClienteSelected;
    }
    await this.searchTransportadoras();
  }

  private async setupEditarOferta(): Promise<void> {
    const cliente = this.ofertaDemanda.clientexdel.cliente;
    if (cliente) {
      this.clienteSelected = cliente;
      await this.clienteSelectedInput();
      this.delegationSelected = this.ofertaDemanda.clientexdel.delegacion;
      this.divisaSelected = this.divisas.find(
        (divisa) => divisa.codDivisa === this.ofertaDemanda?.divisa.codDivisa
      )!;
      this.transportadoraSelected =
        this.transportadorasOptions?.find(
          (transportadora) => transportadora.id === this.ofertaDemanda.transportadora?.id
        ) || null;
      this.delegationsOptional =
        this.ofertaDemanda.ubicaciones
          ?.filter((ubicacion) => ubicacion.delegacion.id !== this.delegationSelected?.id)
          .map((ubicacion) => ubicacion.delegacion.id) || [];
      // Step 2
      await this.loadDetallesOfertaForEdit();
      // Step 3
      // obtener fecha de timestamp en formato 'YYYY-MM-DD'
      const formatDate = (date: Date): string =>
        `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date
          .getDate()
          .toString()
          .padStart(2, "0")}`;
      const fecFormateada = formatDate(new Date(this.ofertaDemanda.fecExpirar!));
      this.fechaExpiracion = fecFormateada;
      // obtener hora de timestamp en formato 'HH:MM:SS'
      const formatTime = (date: Date): string =>
        `${date.getHours().toString().padStart(2, "0")}:${date
          .getMinutes()
          .toString()
          .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;
      const horaFormateada = formatTime(new Date(this.ofertaDemanda.fecExpirar!));
      this.horaExpiracion = horaFormateada;
      const coste = this.getCostes.find(
        (c) =>
          c.codTipo === this.ofertaDemanda?.coste.codTipo &&
          c.codParametro === this.ofertaDemanda?.coste.codParametro
      );
      this.costeSelected = coste ?? null;
      this.anonimo = this.ofertaDemanda.checkAnonimo ?? false;

      const transformTasa = (numTasa: number): number => {
        return Math.round(numTasa * 100000);
      };
      this.tasa = transformTasa(this.ofertaDemanda.numTasa ?? 0);
      // Step 4
      this.ofertaPaso4Params = {
        relleno: true,
        cuentaCorriente: this.ofertaDemanda.cuentaCorriente ?? "",
        agNumeroSucursal: this.ofertaDemanda.agNumeroSucursal ?? "",
        ispbBanco: this.ofertaDemanda.ispbBanco ?? "",
        cnpjPersona: this.ofertaDemanda.cnpjPersona ?? "",
        observacionesOferta: this.ofertaDemanda.observaciones ?? "",
      };
    }
  }

  validateFechaAndHoraExpriracion(): void {
    extend("date_future_oferta", {
      validate: async () => {
        if (this.fechaExpiracion && this.horaExpiracion) {
          return (
            new Date(
              Number(this.fechaExpiracion?.split("-")[0]),
              Number(this.fechaExpiracion?.split("-")[1]) - 1,
              Number(this.fechaExpiracion?.split("-")[2]),
              Number(this.horaExpiracion?.split(":")[0]),
              Number(this.horaExpiracion?.split(":")[1])
            ) > new Date()
          );
        }
        return false;
      },
      message: () => this.$t("validation.messages.date_must_future"),
    });
  }

  async searchTransportadoras(): Promise<void> {
    if (this.clienteSelected?.pais.hasTransportadora) {
      const res = await this.$services.transportadoras.fetchAllTransportadorasByCodPaisCorto(
        this.clienteSelected.pais.codPaisCorto
      );
      if (res) {
        this.transportadorasOptions = res;
      }
    }
  }

  get delegations(): IDelegacion[] {
    const d: IDelegacion[] = [];

    if (this.clienteSelected?.clientexdels) {
      this.clienteSelected?.clientexdels.forEach((clientexdel) => {
        if (clientexdel?.delegacion && clientexdel?.active) {
          d.push(clientexdel.delegacion);
        }
      });
      return d.sort((a, b) => this.sortAscending(a, b, "desDelegacion"));
    }
    return [];
  }

  async clienteSelectedInput(): Promise<void> {
    let aux = await this.$services.clientes._fetchCliente(Number(this.clienteSelected?.id));
    if (aux) {
      this.clienteSelected = aux;
      this.isShowBankField = aux.pais.hasInfoBancaria;
    }
    this.delegationsOptional = [];
    this.delegationSelected = null;
    this.divisaSelected = null;
    this.transportadoraSelected = null;

    await this.searchTransportadoras();
    this.limpiarOfertaPaso4();
  }

  async searchSaldosActuales(): Promise<void> {
    if (this.clienteSelected && this.delegationSelected && this.divisaSelected) {
      const res = await this.fetchSaldoActual({
        pkCliente: this.clienteSelected.id!,
        pkDelegacion: this.delegationSelected.id,
        pkDivisa: this.divisaSelected.id,
      });
      if (res?.saldoActual) {
        this.saldoActual = res;
        if (this.saldoActual.saldoActual > 0) {
          this.saldoDisponible = this.saldoActual?.saldoActual;
          this.detallesSaldo = this.saldoActual?.detallesSaldo;
          this.detallesSaldo.forEach((detalleSaldo) => {
            this.$set(detalleSaldo.calidadDenominacion!, "importe", 0);
            this.$set(detalleSaldo.calidadDenominacion!, "importeSelected", false);
            this.$set(detalleSaldo.calidadDenominacion!, "cantidad", 0);
            this.$set(detalleSaldo.calidadDenominacion!, "cantidadSelected", false);
          });
        } else {
          await this.modalAlert();
        }
      } else {
        await this.modalAlert();
      }
    }
  }

  async modalAlert(): Promise<SweetAlertResult> {
    this.saldoDisponible = 0;
    return this.$swal({
      title: this.$t("label.advertencia"),
      text: this.$t("label.saldo.no.disponible"),
      icon: "warning",
    });
  }

  fechaDefecto(): void {
    const currentDate = new Date();

    const formatDate = (date: Date): string =>
      `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date
        .getDate()
        .toString()
        .padStart(2, "0")}`;

    this.fechaExpiracion = formatDate(currentDate);
    this.horaExpiracion = this.clienteSelected?.expirationTime ?? "17:00:00";

    const fechaHoraExpiracion = new Date(`${this.fechaExpiracion}T${this.horaExpiracion}`);

    if (currentDate.getTime() > fechaHoraExpiracion.getTime()) {
      currentDate.setDate(currentDate.getDate() + 1);
      this.fechaExpiracion = formatDate(currentDate);
    }
  }

  get saldoRestante(): number {
    return Number(this.saldoDisponible) - Number(this.saldoOfertar);
  }

  get saldoOfertar(): number {
    let sumaImportes = 0;
    if (this.clienteSelected?.fakeCerts) {
      this.calidadesDenominacion?.forEach((calidadDenominacion) => {
        if (calidadDenominacion.importe) {
          sumaImportes = Number(sumaImportes) + Number(calidadDenominacion.importe);
        }
      });
    } else {
      this.detallesSaldo?.forEach((detalleSaldo) => {
        if (detalleSaldo.calidadDenominacion?.importe) {
          sumaImportes = Number(sumaImportes) + Number(detalleSaldo.calidadDenominacion?.importe);
        }
      });
    }

    return sumaImportes;
  }

  @AsyncComputed()
  async continuarCondition(): Promise<boolean> {
    if (this.phase1) {
      return false;
    } else if (this.phase2) {
      return await this.checkPhase2();
    } else if (this.phase3) {
      return await this.checkPhase3();
    } else if (this.phase4 && (await this.$refs.formOfertar.validate({ silent: true }))) {
      return false;
    } else if (this.phase5) {
      await this.infoOfertar();
    }

    return true;
  }

  async checkPhase2(): Promise<boolean> {
    if (this.clienteSelected?.fakeCerts) {
      if (this.saldoOfertar > 0 && (await this.$refs.formOfertar.validate({ silent: true }))) {
        return false;
      }
    } else if (
      this.saldoOfertar > 0 &&
      this.saldoRestante > 0 &&
      (await this.$refs.formOfertar.validate())
    ) {
      return false;
    }

    return true;
  }

  async checkPhase3(): Promise<boolean> {
    return !(
      this.fechaExpiracion &&
      this.horaExpiracion &&
      this.costeSelected &&
      (await this.$refs.formOfertar.validate({ silent: true }))
    );
  }

  atras(): void {
    if (this.phase2) {
      this.phase1 = true;
      this.phase2 = false;
      if (!this.isEditar) {
        this.detallesSaldo = [];
      }
    } else if (this.phase3) {
      this.phase2 = true;
      this.phase3 = false;
      if (!this.isEditar) {
        this.fechaExpiracion = null;
        this.horaExpiracion = null;
        this.costeSelected = null;
      }
      this.anonimo = false;
    } else if (this.phase4) {
      this.phase3 = true;
      this.phase4 = false;
      if (!this.isEditar) {
        this.limpiarOfertaPaso4();
      }
    } else if (this.phase5) {
      this.phase4 = true;
      this.phase5 = false;
    } else if (!this.phase1 && !this.phase2 && !this.phase3 && !this.phase4 && !this.phase5) {
      this.phase5 = true;
    }
  }

  async continuar(): Promise<void> {
    if (this.phase1) {
      if ((await this.$refs.formOfertar.validate({ silent: true })) && this.divisaSelected) {
        this.phase1 = false;
        this.phase2 = true;
        if (!this.clienteSelected?.fakeCerts && !this.isEditar) {
          await this.searchSaldosActuales();
        }
      }
    } else if (this.phase2) {
      this.phase2 = false;
      this.phase3 = true;
      if (!this.isEditar) {
        this.fechaDefecto();
      }
    } else if (this.phase3) {
      this.phase3 = false;
      this.phase4 = true;
      this.ofertaPaso4Params.relleno = true;
    } else if (this.phase4) {
      this.phase4 = false;
      this.phase5 = true;
    }
  }

  cancelar(): void {
    this.phase5 = false;
    this.phase4 = true;
    this.clearChangesState();
  }

  async infoOfertar(): Promise<void> {
    const detallesOferta: IDetalleOfertaParams[] = [];
    if (!this.clienteSelected?.fakeCerts) {
      this.detallesSaldo.forEach((detalle) => {
        if (detalle.calidadDenominacion && detalle.calidadDenominacion.importe > 0) {
          detallesOferta.push({
            numCantidad: detalle.calidadDenominacion.importe,
            calidadDenominacion: detalle.calidadDenominacion,
          });
        }
      });
    } else {
      this.calidadesDenominacion.forEach((calidadDenominacion) => {
        if (calidadDenominacion && calidadDenominacion.importe > 0) {
          detallesOferta.push({
            numCantidad: calidadDenominacion.importe,
            calidadDenominacion: calidadDenominacion,
          });
        }
      });
    }
    if (
      this.costeSelected &&
      this.divisaSelected &&
      this.delegationSelected &&
      this.clienteSelected
    ) {
      this.ofertaParams = {
        numCantidad: this.saldoOfertar,
        fecExpirar: new Date(this.fechaExpiracion + " " + this.horaExpiracion),
        checkAnonimo: this.anonimo,
        coste: this.costeSelected.id,
        pkDivisa: this.divisaSelected.id,
        pkCliente: this.clienteSelected.id!,
        pkDelegacion: this.delegationSelected.id,
        pkTransportadora: this.transportadoraSelected ? this.transportadoraSelected.id : undefined,
        detallesOferta: detallesOferta,
        numTasa: this.getNumTasa(this.clienteSelected, this.tasa),
        pkDelegaciones: this.delegationsOptionalSelected,
        observacionesOferta: this.ofertaPaso4Params.observacionesOferta ?? undefined,
        cuentaCorriente: this.ofertaPaso4Params.cuentaCorriente ?? undefined,
        agNumeroSucursal: this.ofertaPaso4Params.agNumeroSucursal ?? undefined,
        ispbBanco: this.ofertaPaso4Params.ispbBanco ?? undefined,
        cnpjPersona: this.ofertaPaso4Params.cnpjPersona ?? undefined,
      };
      if (this.ofertaDemanda && this.isEditar) {
        this.ofertaParams.id = this.ofertaDemanda.id;

        // Detectar cambios
        const { hasChanges, changes } = this.detectChanges(this.ofertaDemanda, this.ofertaParams);

        if (hasChanges) {
          // Mostrar modal con los cambios detectados
          this.generateChangesHtml(changes);
          this.hasDetectedChanges = true;
        } else {
          this.changesHtmlContent = "";
          this.hasDetectedChanges = false;
        }
      }
    }
  }

  limpiarOfertaPaso4(): void {
    this.ofertaPaso4Params.cuentaCorriente = null;
    this.ofertaPaso4Params.agNumeroSucursal = null;
    this.ofertaPaso4Params.ispbBanco = null;
    this.ofertaPaso4Params.cnpjPersona = null;
    this.ofertaPaso4Params.observacionesOferta = null;
    this.ofertaPaso4Params.relleno = false;
  }

  ofertar(): void {
    this.$emit("action", { action: "ofertarConfirm", data: this.ofertaParams });
  }

  verifyImporteToZeroInDetalleSaldoById(id: number): void {
    this.detallesSaldo
      .filter((detalleSaldo) => detalleSaldo.id === id)
      .forEach((detalleSaldo) => {
        const importe = detalleSaldo.calidadDenominacion!.importe;
        detalleSaldo.calidadDenominacion!.importe = !importe ? 0 : Number(importe);
      });
  }

  get titleLeftToDelegacionesOpcionales(): string {
    const textLeft = this.delegationSelected?.desDelegacion ?? "";
    const title = this.$t("label.delegaciones.opcionales.form").replace("X", textLeft);
    return this.$t(title);
  }

  calculaCantidad(calidadDenominacion?: ICalidadDenominacion): void {
    if (calidadDenominacion) {
      const result = mathjs.divide(
        calidadDenominacion.importe,
        calidadDenominacion.denominacion!.numValue
      );

      calidadDenominacion.cantidad = Number(mathjs.format(result, { precision: 14 }));
    }
  }

  detectChanges(
    original: IOfertaDemanda,
    updated: IOfertaParams
  ): { hasChanges: boolean; changes: any } {
    const changes: Record<string, any> = {};
    let hasChanges = false;

    // Cantidad
    const originalCantidad = original.cantidadOfertada || original.cantidadDisponible;
    if (originalCantidad !== updated.numCantidad) {
      changes.cantidad = { anterior: originalCantidad, actual: updated.numCantidad };
      hasChanges = true;
    }

    // Fecha de expiracion
    if (original.fecExpirar && updated.fecExpirar) {
      const originalDate = new Date(original.fecExpirar);
      const updatedDate = new Date(updated.fecExpirar);
      if (originalDate.getTime() !== updatedDate.getTime()) {
        changes.fechaExpiracion = {
          anterior: originalDate.toLocaleString(),
          actual: updatedDate.toLocaleString(),
        };
        hasChanges = true;
      }
    }

    // Anonimo
    if (original.checkAnonimo !== updated.checkAnonimo) {
      changes.anonimo = { anterior: original.checkAnonimo, actual: updated.checkAnonimo };
      hasChanges = true;
    }

    // Tasa
    if (this.clienteSelected && original.numTasa !== undefined && updated.numTasa !== undefined) {
      const originalTasa = this.getNumTasa(
        this.clienteSelected,
        Math.round(original.numTasa * 100000)
      );
      if (originalTasa !== undefined && this.existDifferenceInTasa(originalTasa, updated.numTasa)) {
        changes.tasa = { anterior: originalTasa, actual: updated.numTasa };
        hasChanges = true;
      }
    }

    // Divisa
    if (original.divisa.id !== updated.pkDivisa) {
      changes.divisa = {
        anterior: original.divisa.codDivisa,
        actual: this.divisaSelected?.codDivisa,
      };
      hasChanges = true;
    }

    // Delegacion
    if (original.clientexdel.delegacion.id !== updated.pkDelegacion) {
      changes.delegacion = {
        anterior: original.clientexdel.delegacion.desDelegacion,
        actual: this.delegationSelected?.desDelegacion,
      };
      hasChanges = true;
    }

    // Delegaciones Opcionales
    const originalDelegacionPrincipalId = original.clientexdel.delegacion.id;
    const updatedDelegacionPrincipalId = updated.pkDelegacion;

    const originalDelegacionesIds =
      original.ubicaciones
        ?.filter((ubicacion) => ubicacion.delegacion.id !== originalDelegacionPrincipalId)
        .map((ubicacion) => ubicacion.delegacion.id) || [];

    const updatedDelegacionesIds = (updated.pkDelegaciones || []).filter(
      (id) => id !== updatedDelegacionPrincipalId
    );

    const delegacionesAdded = updatedDelegacionesIds.filter(
      (id) => !originalDelegacionesIds.includes(id)
    );
    const delegacionesRemoved = originalDelegacionesIds.filter(
      (id) => !updatedDelegacionesIds.includes(id)
    );

    // Solo reportar si hay delegaciones agregadas o eliminadas
    if (delegacionesAdded.length > 0 || delegacionesRemoved.length > 0) {
      changes.delegacionesOpcionales = {};

      if (delegacionesAdded.length > 0) {
        changes.delegacionesOpcionales.agregadas = delegacionesAdded.map(
          (id) => this.delegations.find((del) => del.id === id)?.desDelegacion || ""
        );
      }

      if (delegacionesRemoved.length > 0) {
        changes.delegacionesOpcionales.eliminadas = delegacionesRemoved.map(
          (id) => this.delegations.find((del) => del.id === id)?.desDelegacion || ""
        );
      }

      hasChanges = true;
    }

    // Transportadora
    const originalTransportadoraId = original.transportadora?.id || null;
    const updatedTransportadoraId = updated.pkTransportadora || null;
    if (originalTransportadoraId !== updatedTransportadoraId) {
      changes.transportadora = {
        anterior: original.transportadora?.descripcion || this.$t("label.sin.transportadora"),
        actual: this.transportadoraSelected?.descripcion || this.$t("label.sin.transportadora"),
      };
      hasChanges = true;
    }

    // Coste
    if (original.coste.id !== updated.coste) {
      changes.coste = {
        anterior: original.coste.codParametro,
        actual: this.costeSelected?.codParametro,
      };
      hasChanges = true;
    }

    // Observaciones
    if ((original.observaciones || "") !== (updated.observacionesOferta || "")) {
      changes.observaciones = {
        anterior: original.observaciones || this.$t("label.sin.observaciones"),
        actual: updated.observacionesOferta || this.$t("label.sin.observaciones"),
      };
      hasChanges = true;
    }

    // Detalles de la oferta - Denominaciones
    if (original.detallesOferta && updated.detallesOferta) {
      const detailChanges = this.compareDetallesOferta(
        original.detallesOferta,
        updated.detallesOferta
      );
      if (detailChanges.hasChanges) {
        changes.denominaciones = detailChanges.changes;
        hasChanges = true;
      }
    }

    return { hasChanges, changes };
  }

  existDifferenceInTasa(originalTasa: number, updatedTasa: number): boolean {
    const diff = Math.abs(originalTasa - updatedTasa);
    const diffRounded = Number(diff.toFixed(5));
    return diffRounded > 0.00001;
  }

  compareDetallesOferta(
    originalDetails: any[],
    updatedDetails: IDetalleOfertaParams[]
  ): { hasChanges: boolean; changes: any[] } {
    const changes: any[] = [];
    let hasChanges = false;

    // Crear mapas para comparacion eficiente
    const originalMap = new Map();
    originalDetails?.forEach((detail) => {
      originalMap.set(detail.soCalidadDenominacion?.id, detail.cantidadOfertada);
    });

    const updatedMap = new Map();
    updatedDetails.forEach((detail) => {
      updatedMap.set(detail.calidadDenominacion.id, detail.numCantidad);
    });

    // Comparar cantidades
    originalMap.forEach((originalAmount, denominacionId) => {
      const updatedAmount = updatedMap.get(denominacionId) || 0;
      if (Math.abs(originalAmount - updatedAmount) > 0.001) {
        changes.push({
          denominacionId,
          anterior: originalAmount,
          actual: updatedAmount,
          denominacion: this.getDenominacionDescription(denominacionId),
        });
        hasChanges = true;
      }
    });

    // Verificar nuevas denominaciones
    updatedMap.forEach((updatedAmount, denominacionId) => {
      if (!originalMap.has(denominacionId) && updatedAmount > 0) {
        changes.push({
          denominacionId,
          anterior: 0,
          actual: updatedAmount,
          denominacion: this.getDenominacionDescription(denominacionId),
          esNueva: true,
        });
        hasChanges = true;
      }
    });

    return { hasChanges, changes };
  }

  getDenominacionDescription(denominacionId: number): string {
    // Buscar en detallesSaldo o calidadesDenominacion
    const detalle = this.detallesSaldo.find((d) => d.calidadDenominacion?.id === denominacionId);
    if (detalle && detalle.calidadDenominacion?.denominacion) {
      return `${detalle.calidadDenominacion.denominacion.codDenominacion} ${detalle.calidadDenominacion.desCalidad}`;
    }

    const calidad = this.calidadesDenominacion.find((c) => c.id === denominacionId);
    if (calidad && calidad.denominacion) {
      return `${calidad.denominacion.codDenominacion} ${calidad.desCalidad}`;
    }

    return "";
  }

  calculaImporte(calidadDenominacion?: ICalidadDenominacion): void {
    if (calidadDenominacion) {
      const result = mathjs.multiply(
        calidadDenominacion.cantidad,
        calidadDenominacion.denominacion!.numValue
      );

      calidadDenominacion.importe = Number(mathjs.format(result, { precision: 14 }));
    }
  }

  async loadDetallesOfertaForEdit(): Promise<void> {
    const detalleOferta = this.ofertaDemanda?.detallesOferta;
    if (!detalleOferta?.length) {
      return;
    }

    const detallesValidos = detalleOferta.filter((detalle) => detalle.soCalidadDenominacion);

    if (this.clienteSelected?.fakeCerts) {
      this.processDetallesForFakeCerts(detallesValidos);
    } else {
      await this.searchSaldosActuales();
      this.processDetallesForSaldos(detallesValidos);
    }
  }

  processDetallesForFakeCerts(detalles: any[]): void {
    detalles.forEach((detalle) => {
      const detalleMatch = this.calidadesDenominacion.find(
        (cd) => cd.id === detalle.soCalidadDenominacion?.id
      );

      if (detalleMatch) {
        this.updateDetalleMatch(detalleMatch, detalle);
      }
    });
  }

  processDetallesForSaldos(detalles: any[]): void {
    detalles.forEach((detalle) => {
      const detalleMatch = this.detallesSaldo.find(
        (d) => d.calidadDenominacion?.id === detalle.soCalidadDenominacion?.id
      );

      if (detalleMatch?.calidadDenominacion) {
        this.updateDetalleMatch(detalleMatch.calidadDenominacion, detalle);
      }
    });
  }

  updateDetalleMatch(target: any, source: any): void {
    this.$set(target, "importe", source.cantidadOfertada);
    this.$set(target, "importeSelected", true);
    this.$set(target, "denominacion", source.soCalidadDenominacion?.denominacion);
    this.$set(target, "cantidadSelected", true);
    this.calculaCantidad(target);
  }

  generateChangesHtml(changes: Record<string, any>): void {
    let htmlContent = '<div class="text-left">';

    Object.entries(changes).forEach(([field, change]) => {
      if (field === "denominaciones") {
        htmlContent += `<div class="mb-2"><strong>${this.$t(
          "label.denominaciones"
        )}:</strong></div>`;
        htmlContent += '<ul class="list-unstyled ml-3">';
        change.forEach((denom: any) => {
          const anteriorFormatted = this.filterNumber(denom.anterior);
          const actualFormatted = this.filterNumber(denom.actual);
          const status = denom.esNueva
            ? ` <span class="badge badge-success">${this.$t("label.nueva")}</span>`
            : "";
          htmlContent += `<li>• ${denom.denominacion}: <span class="text-muted">${anteriorFormatted}</span> - <strong>${actualFormatted}</strong>${status}</li>`;
        });
        htmlContent += "</ul>";
      } else if (field === "delegacionesOpcionales") {
        htmlContent += `<div class="mb-2"><strong>${this.$t(
          "label.delegaciones.opcionales"
        )}:</strong></div>`;
        htmlContent += '<ul class="list-unstyled ml-3">';

        // Solo mostrar delegaciones agregadas
        if (change.agregadas && change.agregadas.length > 0) {
          change.agregadas.forEach((del: string) => {
            htmlContent += `<li>• ${del} <span class="badge badge-success">${this.$t(
              "label.agregada"
            )}</span></li>`;
          });
        }

        // Solo mostrar delegaciones eliminadas
        if (change.eliminadas && change.eliminadas.length > 0) {
          change.eliminadas.forEach((del: string) => {
            htmlContent += `<li>• ${del} <span class="badge badge-danger">${this.$t(
              "label.eliminada"
            )}</span></li>`;
          });
        }
        htmlContent += "</ul>";
      } else if (field === "anonimo") {
        const anteriorText = change.anterior ? this.$t("label.si") : this.$t("label.no");
        const actualText = change.actual ? this.$t("label.si") : this.$t("label.no");
        const fieldName = this.getFieldDisplayName(field);
        htmlContent += `<div class="mb-2"><strong>${fieldName}:</strong> <span class="text-muted">${anteriorText}</span> - <strong>${actualText}</strong></div>`;
      } else if (field === "cantidad") {
        const fieldName = this.getFieldDisplayName(field);
        const anteriorFormatted = this.filterNumber(change.anterior);
        const actualFormatted = this.filterNumber(change.actual);
        htmlContent += `<div class="mb-2"><strong>${fieldName}:</strong> <span class="text-muted">${anteriorFormatted}</span> - <strong>${actualFormatted}</strong></div>`;
      } else {
        const fieldName = this.getFieldDisplayName(field);
        htmlContent += `<div class="mb-2"><strong>${fieldName}:</strong> <span class="text-muted">${change.anterior}</span> - <strong>${change.actual}</strong></div>`;
      }
    });

    htmlContent += "</div>";
    this.changesHtmlContent = htmlContent;
  }

  getFieldDisplayName(field: string): string {
    const displayNames: Record<string, string> = {
      cantidad: this.$t("label.cantidad"),
      fechaExpiracion: this.$t("label.fecha.expiracion"),
      anonimo: this.$t("label.oferta.anonima"),
      tasa: this.$t("label.tasa"),
      divisa: this.$t("label.divisa"),
      delegacion: this.$t("label.delegacion"),
      transportadora: this.$t("label.transportadora"),
      coste: this.$t("label.coste"),
      observaciones: this.$t("label.observaciones"),
      delegacionesOpcionales: this.$t("label.delegaciones"),
    };

    return displayNames[field] || field;
  }

  clearChangesState(): void {
    this.hasDetectedChanges = false;
    this.changesHtmlContent = "";
  }

  get isEditar(): boolean {
    return this.actionSource === ActionOnOfertaDemanda.EDITAR;
  }

  get ofertaDescription(): string {
    return this.isEditar
      ? this.$t("label.ofertar.fondos.confirmacion.modificar")
      : this.$t("label.aviso.oferta");
  }
}
</script>

<style lang="scss" scoped>
.recent-label {
  font-size: 15px;
  line-height: 40px;
  color: var(--secundario-prosegur-claro);
}

.btn-number {
  border-color: transparent;
  background-color: #ffd102;
}

.separator {
  border-right-color: gainsboro;
  border-right-style: solid;
  border-right-width: 1px;
}

.carousel-transferencias {
  padding: 0 0.75rem;
}

.detalle-transferencias {
  padding-right: 0.5rem;
}

.card-body {
  margin: 0;
  padding: 0;
}

.card-header,
.card-text {
  padding: 1rem;
}

hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.input-card {
  margin: 1rem 0;
  padding: 1rem;
  border-radius: 6px;
  border: solid 0.7px #f1f0f0;
  background-color: rgba(255, 209, 2, 0.04);
}

.textarea {
  height: 150px;
  width: 100%;
  border-radius: 6px;
  border: solid 1px #ced4da;
}

.denominacion-importe {
  color: var(--amarillo-prosegur);
}

.modal-transferencias-footer {
  position: absolute;
  bottom: 0;
  right: 1rem;
}

.resumen {
  min-height: 13rem;
  margin: -2.6rem -1rem 2rem;
  background-color: var(--amarillo-prosegur);
}

.panel-denominaciones {
  overflow: auto;
  max-height: 55vh;
}
.btn-group-toggle::v-deep .btn-outline-primary {
  border-radius: 6px !important;
}
.resume-label {
  font-size: 13px;
  display: block;
  color: var(--secundario-prosegur-claro);
}
.label-15 {
  font-size: 15px;
  color: var(--secundario-prosegur-claro);
}
.label-17 {
  font-size: 17px;
  color: var(--secundario-prosegur-oscuro);
}
.label-21 {
  font-size: 17px;
  color: var(--secundario-prosegur-oscuro);
}
.label-ofertado {
  padding-right: 0;
}
.container_OfertarForm {
  min-height: 300px;
}
.form_OfertarForm {
  padding: 1rem;
}
.label_TitleLeftToDelegacionesOpcionales {
  line-height: 1.23;
  color: #6f6f6f;
  min-height: 16px;
  padding-bottom: 0.5rem;
  font-size: 12px;
  cursor: pointer;
}
.error-divisa {
  color: #dc3545;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
}
.radio-form-group {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
  flex-direction: row;
  flex-wrap: wrap;
}
.form-radio {
  flex: none !important;
  margin-bottom: 10px;
}
.changes-content {
  .changes-list {
    max-height: 300px;
    overflow-y: auto;
  }

  .badge {
    font-size: 0.75em;
  }

  .text-muted {
    text-decoration: line-through;
  }

  .alert-heading {
    color: var(--secundario-prosegur-oscuro) !important;
    font-weight: 600 !important;
    margin-bottom: 1rem !important;
    font-size: 1rem !important;
  }
}
::v-deep .description_PConfirm {
  max-width: 600px !important;
  padding-bottom: 1rem !important;
}
</style>
